(function ($) {


  const Init = (() => {

    let website = {},
      load = {},
      resize = {},
      resizeW = {},
      scroll = {},
      orientation = {},
      mod = {},
      anime = {},
      scrollOption = {},
      parallax = {},
      drawer = {},
      wp = {},
      slider = {},
      top = {},
      basic = {};

    website = {
      page: document.body.dataset.page,
      url: document.URL,
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
      scrollY: window.pageYOffset,
      scrollCurrent: 0,
      breakpoint: { pc: 1200, tb: 992, sp: 768, ss: 576 },
      ua: navigator.userAgent.toLowerCase(),
      isDesktop: true,
      isMobile: false,
      isFirst: true,
      animationFrame: null,

      headTag: document.getElementById('js-header'),
      footTag: document.getElementById('js-footer'),
      // headTag       : $('#js-header'),
      // footTag       : $('#js-footer'),

      act: 'is-act',
      inact: 'is-inact',
      actView: 'is-view',
      actOpen: 'is-open',
      loaded: 'is-loaded',

      targetAnime: 'js-anime',
      actAnime: 'is-anime',
      shiftPoint: 0,
      shiftPc: 5,
      shiftSp: 10,
    };
    website.shiftPoint = website.breakpoint.tb;

    load = {
      functions: [],
      length: 0,
    };

    resize = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };
    resizeW = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };

    scroll = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };

    orientation = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };




    



    const WinLoad = {



    



      init() {



        window.addEventListener('load', function(e) {



          WinLoad.update();



        });



    



        console.log('!-- load init --!');



      },



    



      add(func) {



        load.functions.push(func);



        load.length = load.functions.length;



      },



    



      remove(func) {



        load.functions.splice(func, 1);



        load.length = load.functions.length;



      },



    



      update() {



        for ( let i = 0; i < load.length; i++ ) {



          let func = load.functions[i];



          func();



        }



      },



    



    }



    



    



    const WinResize = {



    



      init() {



        window.addEventListener('resize', function(e) {



          if ( !resize.isRunning ) {



            resize.isRunning = true;



    



            resize.animationFrame = window.requestAnimationFrame( WinResize.update );



    



            // if ( window.requestAnimationFrame ) {



            //   window.requestAnimationFrame(() => {



            //     WinResize.update();



            //   });



            // } else {



            //   setTimeout(() => {



            //     WinResize.update();



            //   }, 1000/resize.fps);



            // }



          }



        });



    



        console.log('!-- resize init --!');



      },



    



      add(func) {



        resize.functions.push(func);



        resize.length = resize.functions.length;



      },



    



      remove(func) {



        resize.functions.splice(func, 1);



        resize.length = resize.functions.length;



      },



    



      update() {



        website.winWidth  = window.innerWidth;



        website.winHeight = window.innerHeight;



        website.ua        = navigator.userAgent.toLowerCase();



    



        for ( let i = 0; i < resize.length; i++ ) {



          let func = resize.functions[i];



          func();



        }



    



        resize.isRunning = false;



      },



    



    }



    



    



    const WinResizeWidth = {



    



      init() {



        window.addEventListener('resize', function(e) {



          if ( website.winWidth != window.innerWidth && !resizeW.isRunning ) {



            resizeW.isRunning = true;



            resizeW.animationFrame = window.requestAnimationFrame( WinResizeWidth.update );



          }



        });



    



        console.log('!-- resizeW init --!');



      },



    



      add(func) {



        resizeW.functions.push(func);



        resizeW.length = resizeW.functions.length;



      },



    



      remove(func) {



        resizeW.functions.splice(func, 1);



        resizeW.length = resizeW.functions.length;



      },



    



      update() {



        for ( let i = 0; i < resizeW.length; i++ ) {



          let func = resizeW.functions[i];



          func();



        }



    



        resizeW.isRunning = false;



      },



    



    }



    



    



    const WinScroll = {



    



      init() {



        window.addEventListener('scroll', function(e) {



          if ( !scroll.isRunning ) {



            scroll.isRunning = true;



    



            scroll.animationFrame = window.requestAnimationFrame( WinScroll.update );



    



            // if ( window.requestAnimationFrame ) {



            //   window.requestAnimationFrame(() => {



            //     WinScroll.update();



            //   });



            // } else {



            //   setTimeout(() => {



            //     WinScroll.update();



            //   }, 1000/scroll.fps);



            // }



          }



        });



    



        console.log('!-- scroll init --!');



      },



    



      add(func) {



        scroll.functions.push(func);



        scroll.length = scroll.functions.length;



      },



    



      remove(func) {



        scroll.functions.splice(func, 1);



        scroll.length = scroll.functions.length;



      },



    



      update() {



        website.winHeight = window.innerHeight;



        website.scrollY   = window.pageYOffset;



    



        for ( let i = 0; i < scroll.length; i++ ) {



          let func = scroll.functions[i];



          func();



        }



    



        scroll.isRunning = false;



      },



    



    }



    



    



    const OrientationChange = {



    



      init() {



        window.addEventListener('orientationchange', function(e) {



          if ( !orientation.isRunning ) {



            orientation.isRunning = true;



    



            orientation.animationFrame = window.requestAnimationFrame( OrientationChange.update );



          }



        });



    



        console.log('!-- orientationchange init --!');



      },



    



      add(func) {



        orientation.functions.push(func);



        orientation.length = orientation.functions.length;



      },



    



      remove(func) {



        orientation.functions.splice(func, 1);



        orientation.length = orientation.functions.length;



      },



    



      update() {



        for ( let i = 0; i < orientation.length; i++ ) {



          let func = orientation.functions[i];



          func();



        }



    



        orientation.isRunning = false;



      },



    



    }



    

    
    const Modules = {
    
      init() {
        mod = {
          targetSmooth: 'js-scroll',
          smoothSpeed: 600,
    
          // targetTab       : 'js-tab',
    
          // targetAccordion : 'js-accordion',
          // targetAccordionSp: 'js-accordionSp',
    
          targetModalOpen: 'js-modal',
          targetModalClose: 'js-modalClose',
          targetModalOverlay: 'js-modalOverlay',
          actBodyModal: 'is-modal',
    
          // targetTmpClone: 'js-tmpClone',
    
          // targetCursor: 'js-cursor',
          // targetCursorTag: '',
          // cursorMagnet: false,
          // cursorClass: website.act,
          // cursorOffClass: website.inact,
    
          // targetAlign     : 'js-align',
          // targetAlignList : [],
          // alignAddClass   : 'u-align_height',
        };
    
        // if (document.getElementById(mod.targetCursor) != null) {
        //   mod.targetCursorTag = document.getElementById(mod.targetCursor);
        //   this.cursor();
        // }
    
        // let alignList = document.querySelectorAll('.' + mod.targetAlign);
        // mod.targetAlignList = Array.prototype.slice.call(alignList, 0);
    
        this.viewportHeight();
        this.scrollbarWidth();
        this.iosCheck();
        this.deviceCheck();
        this.smoothScroll();
        // this.tabBtn();
        // this.accordionBtn();
        this.modalBtn();
        // this.tmpClone();
      },
    
      viewportHeight() {
        let vh = website.winHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      },
      scrollbarWidth() {
        let element = document.createElement('div');
        element.style.visibility = 'hidden';
        element.style.overflow = 'scroll';
        document.body.appendChild(element);
        let scrollbarWidth = element.offsetWidth - element.clientWidth;
        document.body.removeChild(element);
        document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
      },
    
      iosCheck() {
        if (website.ua.indexOf('ipad') > -1 || website.ua.indexOf('iphone') > -1 || (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document)) {
          $('body').addClass('is-ios');
        } else {
          $('body').removeClass('is-ios');
        }
      },
    
      deviceCheck() {
        if (
          website.ua.indexOf('iphone') > -1 ||
          website.ua.indexOf('ipod') > -1 ||
          website.ua.indexOf('android') > -1 && website.ua.indexOf('mobile') > -1
        ) {
          website.isDesktop = false;
          website.isMobile = true;
          $('body').removeClass('is-pc is-tb').addClass('is-sp');
        } else if (
          website.ua.indexOf('ipad') > -1 ||
          website.ua.indexOf('Android') > -1 ||
          (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
        ) {
          website.isDesktop = false;
          website.isMobile = false;
          $('body').removeClass('is-pc is-sp').addClass('is-tb');
        } else {
          website.isDesktop = true;
          website.isMobile = false;
          $('body').removeClass('is-tb is-sp').addClass('is-pc');
        }
      },
    
      smoothScroll() {
        $('.' + mod.targetSmooth + ':not([href=""])').on('click', function () {
          let href = $(this).attr("href"),
            target = $((href == "#") ? 'html' : href),
            shift = ((href != "#")) ? website.headTag.offsetHeight : 0,
            position = target.offset().top - shift;
    
          $('body,html').animate({ scrollTop: position }, mod.smoothSpeed, 'swing');
          return false;
        });
      },
    
      // tabBtn() {
      //   $('.' + mod.targetTab).each(function(){
      //     let tabObj   = $('> li > a', this),
      //         contId   = ( $(this).data('tab') ) ? $(this).data('tab'): '',
      //         contsObj = ( contId ) ? $(contId).children('div'): $(this).next().children('div');
    
      //     tabObj.on('click', function(){
      //       let tabHref = $(this).attr('href');
    
      //       tabObj.removeClass(website.act);
      //       $(this).addClass(website.act);
    
      //       contsObj.hide();
      //       $(tabHref).fadeIn();
    
      //       return false;
      //     });
      //   });
      // },
    
      // accordionBtn() {
      //   $('.' + mod.targetAccordion).on('click', function () {
      //     if ($(this).hasClass(website.act)) {
      //       $(this).removeClass(website.act).next().stop().slideUp('fast');
      //       // $(this).removeClass(website.act);
      //     } else {
      //       $(this).addClass(website.act).next().stop().slideDown();
      //       // $(this).addClass(website.act);
      //     }
      //   });
    
      //   $('.' + mod.targetAccordionSp).on('click', function () {
      //     if (website.winWidth < website.shiftPoint) {
      //       if ($(this).hasClass(website.act)) {
      //         $(this).removeClass(website.act).next().stop().slideUp('fast');
      //         // $(this).removeClass(website.act);
      //       } else {
      //         $(this).addClass(website.act).next().stop().slideDown();
      //         // $(this).addClass(website.act);
      //       }
      //       return false;
      //     }
      //   });
      // },
    
      modalBtn() {
        $(document).on('click', '.' + mod.targetModalOpen, function (e) {
          let href = $(this).attr("href");
          $('html').addClass(mod.actBodyModal);
          $(href).addClass(website.actOpen).parent().addClass(website.act);
          return false;
        });
    
        $('.' + mod.targetModalClose).each(function () {
          $(this).on('click', function () {
            // $('.' + website.actOpen + ' iframe').each(function () {
            //   let playerWindow = $(this)[0].contentWindow;
            //   playerWindow.postMessage('{"event":"command", "func":"pauseVideo", "args":""}', "*");
            // });
    
            $('html').removeClass(mod.actBodyModal);
            $(this).closest('.' + website.actOpen).removeClass(website.actOpen).parent().removeClass(website.act);
          });
        });
    
        $(document).on('click', '.' + mod.targetModalOverlay, function () {
          // $('.' + website.actOpen + ' iframe').each(function () {
          //   let playerWindow = $(this)[0].contentWindow;
          //   playerWindow.postMessage('{"event":"command", "func":"pauseVideo", "args":""}', "*");
          // });
    
          $('html').removeClass(mod.actBodyModal);
          $(this).nextAll('.' + website.actOpen).removeClass(website.actOpen).parent().removeClass(website.act);
        });
      },
    
      // tmpClone() {
      //   $('.' + mod.targetTmpClone).each(function () {
      //     let targetId = $(this).data('tmp'),
      //       loopNum = $(this).data('loop');
    
      //     for (var i = 0; i < loopNum; i++) {
      //       let clone = document.getElementById(targetId).content.cloneNode(true);
      //       this.appendChild(clone);
      //     }
      //   });
      // },
    
      // cursor() {
      //   document.addEventListener('mousemove', function (e) {
      //     if (!mod.cursorMagnet) {
      //       mod.targetCursorTag.style.transform = 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)';
      //     }
      //   });
    
    
      //   let linkElem = document.querySelectorAll('a, button, [data-cursor]');
      //   for (let i = 0; i < linkElem.length; i++) {
      //     linkElem[i].addEventListener('mouseover', function (e) {
      //       if (this.dataset.hover !== undefined) {
      //         mod.cursorClass = this.dataset.hover;
      //       } else {
      //         mod.cursorClass = website.act;
      //       }
      //       mod.targetCursorTag.classList.add(mod.cursorClass);
    
      //       if (this.dataset.magnet !== undefined) {
      //         mod.cursorMagnet = this.querySelector('.' + this.dataset.magnet);
      //       }
    
      //     });
      //     linkElem[i].addEventListener('mouseout', function (e) {
      //       mod.targetCursorTag.classList.remove(mod.cursorClass);
      //       mod.cursorMagnet = false;
      //     });
      //   }
    
      //   let linkOffElem = document.querySelectorAll('[data-cursor-off]');
      //   for (let i = 0; i < linkOffElem.length; i++) {
      //     linkOffElem[i].addEventListener('mouseover', function (e) {
      //       document.body.classList.add(mod.cursorOffClass);
      //     });
      //     linkOffElem[i].addEventListener('mouseout', function (e) {
      //       document.body.classList.remove(mod.cursorOffClass);
      //     });
      //   }
      // },
      // cursorMagnet() {
      //   let cursorMagnetClient = mod.cursorMagnet.getBoundingClientRect();
      //   mod.targetCursorTag.style.transform = 'translate(' + (cursorMagnetClient.left + cursorMagnetClient.width / 2) + 'px, ' + (cursorMagnetClient.top + cursorMagnetClient.height / 2) + 'px)';
      // },
    
      // alignHeight() {
      //   let alignHeight  = 0;
    
      //   mod.targetAlignList.forEach((target) => {
      //     target.style.minHeight = 'auto';
      //     target.classList.add(mod.alignAddClass);
      //     alignHeight = ( target.offsetHeight > alignHeight ) ? target.offsetHeight: alignHeight;
      //     target.classList.remove(mod.alignAddClass);
      //   });
      //   mod.targetAlignList.forEach((target) => {
      //     target.style.minHeight = alignHeight + 'px';
      //   });
      // },
    
    }
    

    
    const DrawerMenu = {
    
      init() {
        drawer = {
          duration: 10,
    
          menu: 'js-drawerMenu',
          menuPanel: 'js-drawerMenuPanel',
          menuToggle: '#js-drawerMenuToggle',
          menuClose: '#js-drawerMenuPanel, #js-drawerMenuClose, #js-drawerMenu .js-scroll',
          menuAct: 'is-menuOpen',
    
          sns: 'js-drawerSns',
          snsPanel: 'js-drawerSnsPanel',
          snsToggle: '#js-drawerSnsToggle',
          snsClose: '#js-drawerSnsPanel, #js-drawerSnsClose, #js-drawerSns .js-scroll',
          snsAct: 'is-snsOpen',
        };
    
        this.menu();
        this.sns();
      },
    
      menu() {
        if (document.getElementById(drawer.menu) != null) {
          let slideoutInst = new Slideout({
            'panel': document.getElementById(drawer.menuPanel),
            'menu': document.getElementById(drawer.menu),
            'duration': drawer.duration,
            'openclass': drawer.menuAct,
          });
    
          let nodeList = document.querySelectorAll(drawer.menuToggle);
          let node = Array.prototype.slice.call(nodeList, 0);
          node.forEach(function (elem, index) {
            elem.addEventListener('click', function () {
              slideoutInst.toggle();
            });
          });
    
          let nodeListClose = document.querySelectorAll(drawer.menuClose);
          let nodeClose = Array.prototype.slice.call(nodeListClose, 0);
          nodeClose.forEach(function (elem, index) {
            elem.addEventListener('click', function () {
              slideoutInst.close();
            });
          });
        }
      },
    
      sns() {
        if (document.getElementById(drawer.sns) != null) {
          let slideoutInst = new Slideout({
            'panel': document.getElementById(drawer.snsPanel),
            'menu': document.getElementById(drawer.sns),
            'duration': drawer.duration,
            'openclass': drawer.snsAct,
          });
    
          let nodeList = document.querySelectorAll(drawer.snsToggle);
          let node = Array.prototype.slice.call(nodeList, 0);
          node.forEach(function (elem, index) {
            elem.addEventListener('click', function () {
              slideoutInst.toggle();
            });
          });
    
          let nodeListClose = document.querySelectorAll(drawer.snsClose);
          let nodeClose = Array.prototype.slice.call(nodeListClose, 0);
          nodeClose.forEach(function (elem, index) {
            elem.addEventListener('click', function () {
              slideoutInst.close();
            });
          });
        }
      },
    
    }
    
    

    
    const Wordpress = {
    
      init() {
        wp = {
          editorTarget: 'js-editor',
          tableClass  : 'c-tbl_responsive',
          iframeclass : 'c-iframe',
        };
    
        this.wpEditor();
      },
    
      wpEditor() {
        if ( document.getElementById(wp.editorTarget) != null ) {
          $( '#' + wp.editorTarget + ' table' ).each(function() {
            $(this).wrap('<div class="' + wp.tableClass + '"></div>');
          });
          $( '#' + wp.editorTarget + ' iframe' ).each(function() {
            $(this).wrap('<div class="' + wp.iframeclass + '"></div>');
          });
        }
        // if ( $('.' + wp.editorTarget).length ) {
        //   $( '.' + wp.editorTarget + ' table' ).each(function() {
        //     $(this).wrap('<div class="' + wp.tableClass + '"></div>');
        //   });
        //   $( '.' + wp.editorTarget + ' iframe' ).each(function() {
        //     $(this).wrap('<div class="' + wp.iframeclass + '"></div>');
        //   });
        // }
      }
    
    }
    
    

    
    const SplideSlider = {
    
      init() {
        slider = {
          headerSnsElm: document.getElementById('js-splideSns'),
          optionsSns: {
            type: 'loop',
            perPage: 2,
            perMove: 2,
            gap: 20,
            autoplay: false,
            // interval: 6000,
            arrows: false,
            pagination: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            breakpoints: {
              991.9: {
                gap: 16,
              },
              767.9: {
                gap: 12,
              },
            },
          },
    
          topKvElm: document.getElementById('js-splideTopKv'),
          optionsKv: {
            type: 'loop',
            perPage: 2,
            perMove: 1,
            gap: 32,
            autoplay: true,
            interval: 6000,
            pagination: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            breakpoints: {
              991.9: {
                gap: 24,
              },
              767.9: {
                perPage: 1,
                arrows: false,
              },
            },
          },
    
          topKvInfoElm: document.getElementById('js-splideTopKvInfo'),
          optionsKvInfo: {
            // type: 'loop',
            // direction: 'ttb',
            // height: '8rem',
            pagination: false,
          },
    
          topInfoElms: document.getElementsByClassName('js-splideInfo'),
          optionsInfo: {
            perPage: 5,
            perMove: 1,
            gap: 24,
            // autoplay: true,
            // interval: 6000,
            pagination: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            breakpoints: {
              1799.9: {
                perPage: 4,
              },
              1449.9: {
                perPage: 3,
              },
              991.9: {
                perPage: 2,
              },
              767.9: {
                perPage: 1,
                arrows: false,
              },
            },
          },
    
          topBnrElm: document.getElementById('js-splideTopBnr'),
          optionsBnr: {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            // autoplay: true,
            // interval: 6000,
            pagination: false,
            arrows: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            breakpoints: {
              991.9: {
                perPage: 2,
                padding: '8vw',
              },
              575.9: {
                perPage: 1,
              },
            },
          },
    
          loopElm: document.getElementById('js-splideLoop'),
          optionsLoop: {
            autoScroll: {
              speed: 0.5,
              pauseOnHover: false,
              pauseOnFocus: false,
            },
            type: 'loop',
            start: 1,
            perPage: 5,
            gap: '-4vw',
            pagination: false,
            arrows: false,
            breakpoints: {
              1999.9: {
                gap: '-7rem',
              },
              991.9: {
                padding: '5vw',
                perPage: 2,
                gap: '-6rem',
              },
              767.9: {
                padding: '18vw',
                perPage: 1,
              },
              575.9: {
                padding: '6vw',
              },
            },
          },
    
          newsElm: document.getElementById('js-splideNews'),
          newsPrevElm: document.getElementById('js-splideNewsPrev'),
          newsNextElm: document.getElementById('js-splideNewsNext'),
          optionsNews: {
            type: 'loop',
            autoplay: true,
            interval: 6000,
            pagination: false,
            arrows: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            breakpoints: {
              991.9: {
                pagination: true,
              },
            },
          },
    
          meetingElm: document.getElementById('js-splideMeeting'),
          optionsMeeting: {
            gap: '1em',
            autoplay: false,
            pagination: false,
            arrows: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            destroy: true,
            breakpoints: {
              767.9: {
                destroy: false,
                pagination: true,
              },
            },
          },
    
        };
      },
    
      common() {
        if (slider.headerSnsElm != null) {
          const splideSns = new Splide(slider.headerSnsElm, slider.optionsSns);
          splideSns.mount();
        }
    
        if (slider.loopElm != null) {
          const splideLoop = new Splide(slider.loopElm, slider.optionsLoop);
          splideLoop.mount(window.splide.Extensions);
        }
      },
    
      top() {
        if (slider.topKvElm != null) {
          const splideKv = new Splide(slider.topKvElm, slider.optionsKv);
          splideKv.on('move click', function () {
            slider.topKvElm.classList.remove(website.act);
            setTimeout(function () {
              slider.topKvElm.classList.add(website.act);
            }, 10);
          });
          splideKv.on('autoplay:play', function () {
            slider.topKvElm.classList.add(website.act);
          });
          splideKv.mount();
        }
    
        if (slider.topKvInfoElm != null) {
          const splideKvInfo = new Splide(slider.topKvInfoElm, slider.optionsKvInfo);
          splideKvInfo.mount();
        }
    
        if (slider.topInfoElms != null) {
          for (let i = 0; i < slider.topInfoElms.length; i++) {
            const splideInfo = new Splide(slider.topInfoElms[i], slider.optionsInfo);
            splideInfo.mount();
          }
        }
    
        if (slider.topBnrElm != null) {
          const splideBnr = new Splide(slider.topBnrElm, slider.optionsBnr);
          splideBnr.mount();
        }
      },
    
      news() {
        if (slider.newsElm != null) {
          const splideNews = new Splide(slider.newsElm, slider.optionsNews);
          splideNews.mount();
    
          if (slider.newsPrevElm != null && slider.newsNextElm != null) {
            slider.newsPrevElm.addEventListener('click', (e) => {
              console.log(splideNews.Components.Controller.getPrev());
              splideNews.Components.Controller.go('<');
            });
            slider.newsNextElm.addEventListener('click', (e) => {
              console.log(splideNews.Components.Controller.getNext());
              splideNews.Components.Controller.go('>');
            });
          }
        }
      },
    
      meeting() {
        if (slider.meetingElm != null) {
          slider.splideMeeting = new Splide(slider.meetingElm, slider.optionsMeeting);
          slider.splideMeeting.mount();
        }
      },
    
    }
    
    

    
    const PageScroll = {
    
      init() {
        scrollOption = {
          target: document.getElementById('js-inertiabox'),
          translateY: 0,
          contHeight: 0,
          velocity: 0.08,
    
          rootMargin: '0px',
          threshold: 0.1,
    
          dataTargets: document.querySelectorAll('.js-dataObserver'),
          dataOptions: {
            rootMargin: "-50% 0px",
            threshold: 0,
          },
        };
    
        this.observer();
        this.observerData();
      },
    
      set() {
        scrollOption.contHeight = scrollOption.target.getBoundingClientRect().height - 1;
        document.body.style.height = Math.floor(scrollOption.contHeight) + 'px';
      },
    
      smooth() {
        this.set();
    
        let diff = website.scrollY - scrollOption.translateY;
    
        if (diff !== 0) {
          if (Math.abs(diff) > 1) {
            scrollOption.translateY += diff * scrollOption.velocity;
          } else {
            scrollOption.translateY = website.scrollY;
          }
          scrollOption.target.style.transform = 'translate3d(0, -' + scrollOption.translateY + 'px, 0)';
        }
      },
    
      observer() {
        let nodeList = document.querySelectorAll('.' + website.targetAnime + ':not(.' + website.actAnime + ')'),
          targets = Array.prototype.slice.call(nodeList, 0),
          options = {
            rootMargin: scrollOption.rootMargin,
            threshold: scrollOption.threshold,
          };
        let observer = new IntersectionObserver(this.observerCallback, options);
    
        targets.forEach((target) => {
          if (target.dataset.delay) {
            target.style.transitionDelay = target.dataset.delay + 'ms';
          }
    
          observer.observe(target);
        });
      },
    
      observerCallback(entries, object) {
        entries.forEach(function (entry, i) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add(website.actAnime);
          object.unobserve(entry.target);
        });
      },
    
    
      observerData() {
        let observer = new IntersectionObserver(this.observerCallbackData, scrollOption.dataOptions);
    
        scrollOption.dataTargets.forEach((target) => {
          observer.observe(target);
        });
      },
      observerCallbackData(entries, object) {
        entries.forEach(function (entry, i) {
          if (entry.target.parentNode.dataset.breakpoint && website.winWidth >= website.breakpoint[entry.target.parentNode.dataset.breakpoint]) return;
    
          if (entry.isIntersecting) {
            let dataIndex = Number(entry.target.dataset.index),
              dataType = entry.target.parentNode.dataset.type;
    
            if (
              (dataIndex !== '' && typeof dataIndex !== "undefined") &&
              (dataType !== '' && typeof dataType !== "undefined")
            ) {
              slider[dataType].Components.Controller.go(dataIndex);
            }
    
          }
        });
      },
    }
    


    // OFF
    // ./inc/_animation.js

    // ./inc/_parallax.js




    const TopPage = {

      init() {
        top = {};

        SplideSlider.top();
      },

      update() {
      },

    }


    const BasicPage = {

      init() {
        basic = {
          // pageTopTag: document.getElementById('js-pageTop'),
          // megaMenuTarget: 'js-megaMenu',
          // megaMenuFadeOut: 400,

          singleTtlFrame: document.getElementById('js-newsSingleTtl'),

          masonryElms: document.getElementsByClassName('js-masonry'),

          calendarElm: document.getElementById('js-clubCalendar'),
          calendarHeaderTop: 0,
        };

        // this.pageTop();
        this.headerScroll();
        this.masonry();
        this.meetingCalendarScrollX();

        setTimeout(() => {
          this.meetingCalendarHeader();
        }, 200);
        // this.megaMenuView();
        // this.scrollUpView();

        SplideSlider.common();

        if (website.page === 'news-single') {
          SplideSlider.news();
          this.singleTtlHeight();
        }
        if (website.page === 'meeting') {
          SplideSlider.meeting();
        }
      },

      // pageTop() {
      //   if (basic.pageTopTag != null) {
      //     if (website.scrollY <= 100) {
      //       basic.pageTopTag.classList.remove(website.actView);
      //     } else {
      //       basic.pageTopTag.classList.add(website.actView);
      //     }
      //   }
      // },

      headerScroll() {
        if (website.scrollY <= 50) {
          website.headTag.classList.remove(website.act);
        } else {
          website.headTag.classList.add(website.act);
        }
      },

      singleTtlHeight() {
        if (basic.singleTtlFrame != null) {
          document.documentElement.style.setProperty('--singleTtlHeight', `${basic.singleTtlFrame.clientHeight}px`);
        }
      },

      masonry() {
        if (basic.masonryElms != null) {
          for (let i = 0; i < basic.masonryElms.length; i++) {
            const masonry = basic.masonryElms[0];
            const childElms = masonry.children;
            const rowHeight = parseInt(window.getComputedStyle(masonry).getPropertyValue('grid-auto-rows'));

            for (let i = 0; i < childElms.length; i++) {
              const rowSpan = Math.ceil(childElms[i].querySelector("*").clientHeight / rowHeight);
              childElms[i].style.gridRowEnd = 'span ' + rowSpan;
            }
          }
        }
      },

      meetingCalendarHeader() {
        if (basic.calendarElm != null) {
          basic.calendarHeaderTop = (basic.calendarElm.getBoundingClientRect().top * -1) + website.headTag.offsetHeight;

          if (basic.calendarHeaderTop > 0) {
            basic.calendarElm.children[0].style.top = `${basic.calendarHeaderTop}px`;
          } else {
            basic.calendarElm.children[0].style.top = `0px`;
          }
        }
      },

      meetingCalendarScrollX() {
        if (basic.calendarElm != null) {
          const now = new Date();
          const month = now.getMonth() + 1;

          const targetWidth = basic.calendarElm.clientWidth;
          const targetChildren = basic.calendarElm.children;
          const childWidth = targetChildren[0].getBoundingClientRect().width;
          const grandChildWidth = targetChildren[0].children[1].getBoundingClientRect().width;

          const nowMonthPos = (month <= 3) ? grandChildWidth * (month + 8) : grandChildWidth * (month - 4);

          const differenceWidth = childWidth - targetWidth;

          if (differenceWidth > 0) {
            basic.calendarElm.scrollLeft = nowMonthPos;
          }
        }
      },

      // megaMenuView() {
      //   let nodeList = document.querySelectorAll('.' + basic.megaMenuTarget),
      //     timer = {};

      //   nodeList.forEach((target, index) => {
      //     timer[index] = null;

      //     if (website.isDesktop) {
      //       target.addEventListener(`mouseenter`, () => {
      //         clearTimeout(timer[index]);
      //         target.classList.add(website.actView);
      //       });
      //       target.addEventListener(`mouseleave`, () => {
      //         timer[index] = setTimeout(function () { target.classList.remove(website.actView); }, basic.megaMenuFadeOut);
      //       });
      //     } else {
      //       let megamenuNode = target.querySelector('[data-megamenu]');

      //       target.addEventListener(`click`, function (e) {
      //         if (target.classList.contains(website.actView) === true) {
      //           target.classList.remove(website.actView);
      //         } else {
      //           target.classList.add(website.actView);
      //         }
      //       });
      //       megamenuNode.addEventListener(`click`, function (e) {
      //         e.stopPropagation();
      //       });
      //       document.addEventListener('click', (e) => {
      //         if (!e.target.closest('.' + basic.megaMenuTarget)) {
      //           target.classList.remove(website.actView);
      //         }
      //       });
      //     }

      //   });
      // },

      // scrollUpView() {
      //   if (website.scrollY === website.scrollCurrent) {
      //     return;
      //   }

      //   if (website.scrollY <= 10 || website.scrollY < website.scrollCurrent) {
      //     website.headTag.classList.add(website.actView);
      //   } else {
      //     website.headTag.classList.remove(website.actView);
      //   }

      //   website.scrollCurrent = website.scrollY;
      // },

      update() {
      },

    }


    const App = {

      init() {
        if (website.page != 'wp-manual' && website.page != 'wp-manual-single') {
          this.set();
          // this.update();
        } else {
          // Modules.init();
          Wordpress.init();
        }
      },

      set() {
        Modules.init();
        // Animation.init();
        PageScroll.init();
        // Parallax.init();
        DrawerMenu.init();
        Wordpress.init();
        SplideSlider.init();
        BasicPage.init();


        if (website.page == 'top') {
          TopPage.init();
        }


        // WinLoad.add( Animation.check );
        // WinLoad.add( Modules.alignHeight );

        WinResize.add(Modules.iosCheck);
        WinResize.add(Modules.deviceCheck);

        WinResizeWidth.add(Modules.viewportHeight);
        WinResizeWidth.add(Modules.scrollbarWidth);
        WinResizeWidth.add(BasicPage.singleTtlHeight);
        WinResizeWidth.add(BasicPage.masonry);
        // WinResizeWidth.add( Modules.alignHeight );

        // WinScroll.add( Animation.check );
        // WinScroll.add(BasicPage.scrollUpView);
        WinScroll.add(BasicPage.headerScroll);
        WinScroll.add(BasicPage.meetingCalendarHeader);

        // OrientationChange.add( xxx );


        WinLoad.init();
        WinResize.init();
        WinResizeWidth.init();
        WinScroll.init();
        OrientationChange.init();

      },

      update() {
        // website.animationFrame = window.requestAnimationFrame(App.update);
        // website.winWidth = window.innerWidth;
        // website.winHeight = window.innerHeight;
        // website.scrollY = window.pageYOffset;

        // if (website.isDesktop) {
        //   PageScroll.smooth();

        //   if (mod.cursorMagnet) {
        //     Modules.cursorMagnet();
        //   }

        //   if (website.page == 'top') {
        //     Parallax.moveImg();
        //   }
        // }
      },

    }


    App.init();

  })();


})(jQuery);
